import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { toAbsoluteUrl } from "../../services";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  let { data, children, current, onChange, tabTextColor } = props;

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          variant="scrollable"
          value={current}
          onChange={onChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#FFD700",
            },
          }}
        >
          {data.map((tabItem, i) => {
            return (
              <Tab
                style={{
                  color: current === i ? "#4B4141" : '#4B4141B2',
                  textTransform: "capitalize",
                  fontWeight: "600",
                  backgroundColor: current === i ? "#007E8B" : "#E1E1E1",
                  marginRight: "3px",
                }}
                className="flex justify-center items-center"
                key={i}
                icon={
                  tabItem.paid ? (
                    <div className="flex flex-row justify-center items-center">
                      <p>{tabItem.name}</p>
                      <img
                        src={toAbsoluteUrl(
                          current === i
                            ? "/media/login/daimond.png"
                            : "/media/login/daimond.png"
                        )}
                        alt="upgrade icon"
                        className={`h-5  w-5  object-contain ml-2`}
                      />
                    </div>
                  ) : (
                    <p>{tabItem.name}</p>
                  )
                }
                {...a11yProps(0)}
              />
            );
          })}
        </Tabs>
      </Box>
      <TabPanel value={current} index={current}>
        {children}
      </TabPanel>
    </Box>
  );
}
